import React from 'react'
import UiInput from '../../../_uiComponents/UiInput';
import { UiButton } from '../../../../_uiComponents/common/form/UiButton';
import Grid from '@mui/material/Grid';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { Box } from '@mui/material';

export default function ResetPassword(props) {
    const Minimum = true;
    return (
        <>
            <Box component="div" sx={{ width: '100%' }}>
                <UiInput type="password" label="New Password" />
                <div className='sba-password-restrictions'>
                    <ul>
                        <li><CheckOutlinedIcon style={Minimum ? { color: 'green' } : {}} /> Minimum 8 Characters</li>
                        <li><CheckOutlinedIcon /> Special Characters</li>
                        <li><CheckOutlinedIcon /> Uppercase Characters</li>
                        <li><CheckOutlinedIcon /> Lowercase Characters</li>
                        <li><CheckOutlinedIcon /> Numeric Characters</li>
                    </ul>
                </div>
                <UiInput type="password" label="Confirm New Password" />

                <Grid container sx={{ mb: 1.3 }}>
                    <Grid item xs sx={{ textAlign: 'right' }}>
                        <UiButton name="Next" variant="contained" size="large" />
                    </Grid>
                </Grid>
                <p className='sba-login-bottom-support-mail'>Please reach <span>support@sherbetrewards.com </span>for further queries</p>
            </Box>
        </>
    )
}
